import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {OttopilotAnalyticsWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotAnalyticsWorkspaceCapability/domain/OttopilotAnalyticsWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotAnalyticsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotAnalytics> & {
    fixedUdoTemplates: {
        [OttopilotAnalyticsWorkspaceCapabilityUdoTemplateKey.dataset]: {
            udoAdditionalColumnIds: {
                columns: Uuid;
                createdBy: Uuid;
                datasetType: Uuid;
                displayName: Uuid;
                granularity: Uuid;
                updatedBy: Uuid;
            };
        };
    };
};

export const ottopilotAnalyticsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [OttopilotAnalyticsWorkspaceCapabilityUdoTemplateKey.dataset]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                columns: uuidZodValidator,
                datasetType: uuidZodValidator,
                displayName: uuidZodValidator,
                granularity: uuidZodValidator,
                createdBy: uuidZodValidator,
                updatedBy: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<OttopilotAnalyticsWorkspaceCapabilityUdoBindings>;
